import { Component, Input, OnChanges, OnDestroy, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';
import { extractQuillAlignment, QuillAlignment } from '../../../quill-utils';

const TIME_LEFT_TOKEN = '{time_left}';
const SAMPLE_TIME_LEFT = '2hrs 21mins';

@Component({
  selector: 'cutoff-timer-component-preview',
  templateUrl: './cutoff-timer-component-preview.component.html',
  styleUrls: ['./cutoff-timer-component-preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CutoffTimerComponentPreviewComponent implements OnChanges, OnDestroy {
  @Input() options: ShopPlugin.ProductPagePromise.CutoffTimerOptions;
  @Input() zipCodeAvailable = true;

  iconSrc = '';
  textAlignment: QuillAlignment = 'left';

  private currentObjectUrl: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.refreshIconSrc();
      this.textAlignment = extractQuillAlignment(this.options?.displayMessage);
    }
  }

  ngOnDestroy(): void {
    this.revokeObjectUrl();
  }

  get isVisible(): boolean {
    if (!this.zipCodeAvailable) return false;
    return this.options?.position === ShopPlugin.ProductPagePromise.CutoffTimerPosition.STANDALONE;
  }

  get renderedHtml(): string {
    const message = this.options?.displayMessage ?? '';
    return message.replace(TIME_LEFT_TOKEN, `<b>${SAMPLE_TIME_LEFT}</b>`);
  }

  get backgroundStyle(): { [key: string]: string } {
    const color = this.options?.backgroundColor;
    return color ? { background: color } : {};
  }

  get hasBackground(): boolean {
    return !!this.options?.backgroundColor;
  }

  private refreshIconSrc(): void {
    const value = this.options?.iconUrl as unknown;
    this.revokeObjectUrl();
    if (typeof value === 'string') {
      this.iconSrc = value;
    } else if (value instanceof File) {
      this.currentObjectUrl = URL.createObjectURL(value);
      this.iconSrc = this.currentObjectUrl;
    } else {
      this.iconSrc = '';
    }
  }

  private revokeObjectUrl(): void {
    if (this.currentObjectUrl) {
      URL.revokeObjectURL(this.currentObjectUrl);
      this.currentObjectUrl = null;
    }
  }
}
